module.exports = "/_next/static/images/img_live_sprite.VeHs8N1q.png";